<template>
    <section>
        <div class="min-h-screen bg-blue-50 overflow-hidden w-full">
            <div class="h-full flex">
                <div class="flex flex-col min-w-0 flex-1 overflow-hidden">
                    <div class="flex-1 relative z-0 flex overflow-hidden">
                        <main
                            class="flex-1 relative z-0 overflow-y-auto focus:outline-none xl:order-last"
                        >
                            <article
                                class="w-full bg-blue-50 shadow-2xl shadow-inner"
                            >
                                <router-view
                                    v-slot="{ Component }"
                                    name="details"
                                    class="bg-blue-50 px-4 lg:px-0"
                                >
                                    <transition name="fade" mode="out-in">
                                        <component :is="Component"></component>
                                    </transition>
                                </router-view>
                            </article>
                        </main>
                        <aside
                            class="xl:order-first xl:flex xl:flex-col flex-shrink-0 w-96 border-r border-gray-200 h-screen bg-white sticky bottom-0"
                        >
                            <div class="flex-shrink-0 px-4 flex items-center">
                                <logo-nl
                                    height="h-32  text-white mx-auto"
                                    class="h-32 text-white mx-auto mt-6"
                                ></logo-nl>
                            </div>

                            <members-table></members-table>
                        </aside>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-active {
    opacity: 0;
}
</style>
<script>
import {
    Dialog,
    DialogOverlay,
    Switch,
    SwitchGroup,
    SwitchLabel,
    TransitionChild,
    TransitionRoot,
} from "@headlessui/vue";
import {
    BellIcon,
    CalendarIcon,
    ChatIcon,
    CogIcon,
    UserGroupIcon,
    HomeIcon,
    MenuAlt2Icon,
    QuestionMarkCircleIcon,
    UsersIcon,
    XIcon,
} from "@heroicons/vue/outline";
import { SearchIcon } from "@heroicons/vue/solid";

// const navigation = [
//     { name: "Dashboard", href: "dashboard", icon: HomeIcon },
//     { name: "Vergaderingen", href: "meetings", icon: CalendarIcon },
//     { name: "Deelnemers", href: "attendees", icon: UserGroupIcon },
//     // { name: "Messages", href: "home", icon: ChatIcon },
//     // { name: "Team", href: "home", icon: UsersIcon },
//     { name: "Instellingen", href: "profile", icon: CogIcon },
// ];
export default {
    mounted() {
        Eventing.listen("openSidebar", () => (this.sidebarOpen = true));
        // alert("HEY");

        this.navigation = [
            {
                name: this.t("navigation.dashboard", "Dashboard"),
                href: "dashboard",
                icon: HomeIcon,
            },
            {
                name: this.t("navigation.vergaderingen", "Vergaderingen"),
                href: "meetings",
                icon: CalendarIcon,
            },
            {
                name: this.t("navigation.deelnemers", "Deelnemers"),
                href: "attendees",
                icon: UserGroupIcon,
            },
            // { name: "Messages", href: "home", icon: ChatIcon },
            // { name: "Team", href: "home", icon: UsersIcon },
            {
                name: this.t("navigation.instellingen", "Instellingen"),
                href: "profile",
                icon: CogIcon,
            },
        ];
    },
    components: {
        Dialog,
        DialogOverlay,
        Switch,
        SwitchGroup,
        SwitchLabel,
        TransitionChild,
        TransitionRoot,
        BellIcon,
        MenuAlt2Icon,
        SearchIcon,
        XIcon,
    },
    created() {},
    props: [],
    data() {
        return {
            sidebarOpen: false,
            automaticTimezoneEnabled: true,
            autoUpdateApplicantDataEnabled: false,
            navigation: {},
        };
    },
    methods: {
        checkCurrent(route) {
            return this.$route.name.split("-")[0].includes(route.split("-")[0])
                ? true
                : false;
        },
    },
};
</script>
